import { useState, useEffect, useRef } from "react";
import ConfirmDialog from "./ui/ConfirmDialog";
import { useApi } from "../hooks/useApi";

export default function EmailEveryoneButton() {
    const { apiCall } = useApi();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [msg, setMsg] = useState(false);
    const isDevelopment = import.meta.env.VITE_APP_ENV === 'development';

    const scheduleEmailForEveryone = () => {
        if (inProgress) return;

        setInProgress(true);

        let success = false;
        apiCall(`scheduleEmailForEveryone`, {
            method: "POST",
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setIsDialogOpen(false);
                    success = true;
                    if (data.message) {
                        alert(data.message);
                    }
                } else {

                    if (data.error) {
                        alert(data.error);
                    }
                    else {
                        alert("Error setting up the reminder.");
                    }

                }

            }).finally((data) => {
                setInProgress(false);

            });

    };


    return (
        <div>

            <div className="text-gray-700 font-medium mb-2 text-center">
                <button onClick={() => { setIsDialogOpen(true) }} className="mt-3 cursor-pointer bg-blue-500 text-amber-50 p-2  hover:bg-amber-500 rounded transition-colors">Send Email to Everyone</button>
            </div>
            <ConfirmDialog
                open={isDialogOpen}
                title="Send an Email to everyone"
                message={(msg ? msg : ('Are you sure you want to send this email to everyone that has emails enabled?<br><em>(excludes users that are exclusively on completed projects)</em>' + (isDevelopment ? '<br><br><small>Only the testers will be emailed in Dev Mode</small>' : '')))}
                confirmText="Send"
                cancelText="Cancel"
                onConfirm={scheduleEmailForEveryone}
                inProgress={inProgress}
                onCancel={() => setIsDialogOpen(false)}
            />




        </div>

    );
};
